import { useMemo } from "react";
import Highcharts from "highcharts";
import { Chart } from "@highcharts/react";
import exporting from "highcharts/modules/exporting";
import exportData from "highcharts/modules/export-data";
import offlineExporting from "highcharts/modules/offline-exporting";
import { pieChartData, PieChartDataPoint } from "../mockData";
import "../style.css";
import { DataOptions, SeriesOptionsType } from "highcharts/highcharts.src";

type TProps = {
  title?: string;
  series: SeriesOptionsType[];
  /**
   * Per-slice labels around the pie. They are always on screen and their
   * leader lines reserve a wide margin, which shrinks the pie itself — turn
   * them off where the legend already names the slices and the hover tooltip
   * carries the numbers.
   */
  dataLabels?: boolean;
};

export function PieChart(props: TProps) {
  const { series, title, dataLabels = true } = props;
  const chartOptions = useMemo(() => {
    return {
      chart: {
        type: "pie",
        height: null,
        width: null,
      },
      title: {
        text: title,
      },
      // tooltip: {
      //   pointFormat:
      //     "{series.name}: <b>{point.percentage:.1f}%</b><br/>Value: <b>{point.y}</b>",
      // },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: dataLabels,
            format: "<b>{point.name}</b>: {point.percentage:.1f} %",
          },
          showInLegend: true,
        },
      },
      series: series,
      // series: [
      //   {
      //     name: "Share",
      //     colorByPoint: true,
      //     data: data,
      //   },
      // ],
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: true,
        showTable: false,
        buttons: {
          contextButton: {
            menuItems: [
              "printChart",
              "separator",
              "downloadPNG",
              "downloadJPEG",
              "downloadPDF",
              "downloadSVG",
              "separator",
              "downloadCSV",
              "downloadXLS",
              "separator",
              "viewData",
            ],
          },
        },
      },
      // responsive: {
      //   rules: [
      //     {
      //       condition: {
      //         maxWidth: 500,
      //       },
      //       chartOptions: {
      //         plotOptions: {
      //           pie: {
      //             dataLabels: {
      //               enabled: false,
      //             },
      //           },
      //         },
      //       },
      //     },
      //   ],
      // },
    };
  }, [series, title, dataLabels]);

  return (
    <div className="chart-wrapper">
      {/*<Chart highcharts={Highcharts} options={chartOptions} />*/}
      <Chart options={chartOptions} />
    </div>
  );
}
